import { type ComponentCreation } from './types'
import { spacing } from '../spacing'

export const createMuiButtonBase = () =>
  ({
    // no more ripple effect!
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          '&.MuiRadio-root': {
            marginLeft: 0,
          },
          '&.MuiTabScrollButton-root': {
            '&.Mui-disabled': {
              display: 'none',
            },
          },
          '&.MuiMenuItem-root': {
            minHeight: spacing(6),
          },
        },
      },
    },
  }) satisfies ComponentCreation
